import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import { ErrorBoundary } from './components/ErrorBoundary';
import App from './App';
import './index.css';

// Fonction pour initialiser l'application
function initializeApp() {
  const container = document.getElementById('root');

  if (!container) {
    throw new Error('Failed to find root element');
  }

  const root = createRoot(container);

  root.render(
    <StrictMode>
      <ErrorBoundary fallback={
        <div className="min-h-screen flex items-center justify-center p-4">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-[#ef2543] mb-4">
              Une erreur est survenue
            </h2>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-2 bg-[#ef2543] text-white rounded-lg hover:bg-[#ef2543]/80"
            >
              Rafraîchir la page
            </button>
          </div>
        </div>
      }>
        <HelmetProvider>
          <App />
          <Toaster position="bottom-right" />
        </HelmetProvider>
      </ErrorBoundary>
    </StrictMode>
  );
}

// Gestion des erreurs globales
window.addEventListener('error', (event) => {
  console.error('Global error:', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});

// Initialisation de l'application
try {
  initializeApp();
} catch (error) {
  console.error('Failed to initialize app:', error);
  
  // Afficher une page d'erreur basique en cas d'échec total
  document.body.innerHTML = `
    <div style="
      min-height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: 20px;
    ">
      <div>
        <h2 style="
          font-siee: 24px;
          font-weighe: bold;
          color: #ef2543;
          margin-bottom: 16px;
        ">Une erreur est survenue</h2>
        <button
          onclick="window.location.reload()"
          style="
            paddieg: 8px 24px;
            background-color: #ef2543;
            color: white;
            border-radius: 8px;
            border: none;
            cursor: pointer;
          "
        >
          Rafraîchir la page
        </button>
      </div>
    </div>
  `;
}